import React, { useState, useEffect, useRef } from 'react';
import { Allotment } from "allotment";
import "allotment/dist/style.css";
import { api } from '../services/axiosConfig';
import DateInput from '../components/DateInput';
import ProjecaoDropdown from '../components/ProjecaoDropdown';
import ProjecaoResultado from '../components/ProjecaoResultado';
import { formatDateToISO, formatDateToBR, isValidBRDate } from '../utils/dateUtils';

function DashboardPage() {
    const [file, setFile] = useState(null);
    const [inpcFile, setInpcFile] = useState(null);
    const [sexo, setSexo] = useState('MASCULINO');
    const [isProfessor, setIsProfessor] = useState(false);
    const [isDeficiente, setIsDeficiente] = useState(false);
    const [grauDeficiencia, setGrauDeficiencia] = useState('LEVE');

    const [filiados, setFiliados] = useState([]);
    const [selectedFiliadoId, setSelectedFiliadoId] = useState(null);


    const [filiado, setFiliado] = useState(null);
    const [vinculos, setVinculos] = useState([]);
    const [tempoSimples, setTempoSimples] = useState('');
    const [tempoConvertido, setTempoConvertido] = useState('');
    const [remuneracoes, setRemuneracoes] = useState([]);

    const [aposentadoriaResult, setAposentadoriaResult] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => setSuccessMessage(''), 5000);
            return () => clearTimeout(timer);
        }
    }, [successMessage]);

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(''), 8000);
            return () => clearTimeout(timer);
        }
    }, [error]);
    const [showAddForm, setShowAddForm] = useState(false);

    const [editedVinculo, setEditedVinculo] = useState(null);
    const [splittingVinculo, setSplittingVinculo] = useState(null);

    const [cardVisibility, setCardVisibility] = useState({
        entrada: true,
        inpc: true,
        resultados: true,
        vinculos: true,
        remuneracoes: true,
        descarte: true,
    });

    const [newVinculo, setNewVinculo] = useState({
        seq: '',
        dataInicio: '',
        dataFim: '',
        empresa: '',
        categoria: 'Empregado ou Agente Público'
    });

    const [editingRemuneracao, setEditingRemuneracao] = useState(null);
    const [newRemuneracao, setNewRemuneracao] = useState(null);
    const [pendingRemuneracaoScroll, setPendingRemuneracaoScroll] = useState(null);
    const remuneracoesContainerRef = useRef(null);

    const [dataReferencia, setDataReferencia] = useState('');
    const [remuneracoesNormalizadas, setRemuneracoesNormalizadas] = useState([]);

    const [calculationResult, setCalculationResult] = useState({});
    const [dib, setDib] = useState('');

    const [descarteResult, setDescarteResult] = useState(null);
    const [showDescarteFullscreen, setShowDescarteFullscreen] = useState(false);
    const [availableCompetencies, setAvailableCompetencies] = useState([]);
    const [activeTab, setActiveTab] = useState(0);

    const [activeMainTab, setActiveMainTab] = useState('calculo');

    // State de projeção (keyed por nome da regra)
    const [projectionResults, setProjectionResults] = useState({});
    const [projectionDropdownOpen, setProjectionDropdownOpen] = useState(null);

    const [mortalidadeFile, setMortalidadeFile] = useState(null);
    const [mortalidadeStatus, setMortalidadeStatus] = useState({
        disponivel: false,
        ano: null
    });

    const [inpcStatus, setInpcStatus] = useState({
        competenciasReferencia: []
    });

    useEffect(() => {
        loadAllFiliados();
        loadAvailableCompetencies();
        loadMortalidadeStatus();
        loadInpcStatus();
    }, []);

    useEffect(() => {
        if (!pendingRemuneracaoScroll || remuneracoes.length === 0) return;
        const container = remuneracoesContainerRef.current;
        if (!container) return;

        const hasId = pendingRemuneracaoScroll.id !== null && pendingRemuneracaoScroll.id !== undefined;
        const hasComposite = pendingRemuneracaoScroll.vinculoSeq !== null
            && pendingRemuneracaoScroll.vinculoSeq !== undefined
            && pendingRemuneracaoScroll.competencia;

        const selector = hasId
            ? `[data-remuneracao-id="${pendingRemuneracaoScroll.id}"]`
            : (hasComposite
                ? `[data-vinculo-seq="${pendingRemuneracaoScroll.vinculoSeq}"][data-competencia="${pendingRemuneracaoScroll.competencia}"]`
                : '');

        if (!selector) return;

        const row = container.querySelector(selector);
        if (row) {
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setPendingRemuneracaoScroll(null);
        }
    }, [pendingRemuneracaoScroll, remuneracoes]);


    const loadAllFiliados = async () => {
        try {
            const response = await api.get('/api/cnis/filiados');
            setFiliados(response.data || []);
        } catch (err) {
            console.error('Erro ao carregar filiados:', err);
            setError('Erro ao carregar lista de filiados.');
        }
    };

    const loadAvailableCompetencies = async () => {
        try {
            const response = await api.get('/api/inpc/competencias');
            setAvailableCompetencies(response.data || []);
        } catch (err) {
            console.error('Erro ao carregar competências:', err);
        }
    };

    const loadMortalidadeStatus = async () => {
        try {
            const response = await api.get('/api/tabela-mortalidade/status');
            setMortalidadeStatus(response.data || {
                disponivel: false,
                ano: null
            });
        } catch (err) {
            console.error('Erro ao carregar status da tábua de mortalidade:', err);
        }
    };

    const loadInpcStatus = async () => {
        try {
            const response = await api.get('/api/inpc/status');
            setInpcStatus(response.data || { competenciasReferencia: [] });
        } catch (err) {
            console.error('Erro ao carregar status do INPC:', err);
        }
    };

    const handleMortalidadeUpload = async () => {
        if (!mortalidadeFile) {
            setError('Por favor, selecione um arquivo para a tábua de mortalidade.');
            return;
        }

        const formData = new FormData();
        formData.append('file', mortalidadeFile);

        setIsLoading(true);
        setError('');
        setSuccessMessage('');

        try {
            const response = await api.post('/api/tabela-mortalidade/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setSuccessMessage(response.data || 'Tábua de mortalidade unissex importada com sucesso!');

            await loadMortalidadeStatus();

            setMortalidadeFile(null);
            const fileInput = document.getElementById('mortalidadeFile');
            if (fileInput) fileInput.value = '';
        } catch (err) {
            setError(err.response?.data || 'Erro ao processar tábua de mortalidade.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleFiliadoSelection = async (filiadoId) => {
        if (!filiadoId) {
            setFiliado(null);
            setVinculos([]);
            setRemuneracoes([]);
            setSelectedFiliadoId(null);
            return;
        }

        setRemuneracoes([]);
        setVinculos([]);
        setFiliado(null);
        setRemuneracoesNormalizadas([]);
        setAposentadoriaResult(null);
        setDescarteResult(null);
        setDataReferencia('');

        try {
            const filiadoResponse = await api.get(`/api/cnis/filiado/${filiadoId}`);
            setFiliado(filiadoResponse.data);
            setSexo(filiadoResponse.data.sexo || 'MASCULINO');
            setSelectedFiliadoId(filiadoId);

            await loadDashboardData(filiadoId);
        } catch (err) {
            console.error('Erro ao carregar dados do filiado:', err);
            setError('Erro ao carregar dados do filiado selecionado.');
        }
    };

    const loadDashboardData = async (filiadoId) => {
        if (!filiadoId) return;
        setIsLoading(true);
        setError('');
        try {
            const results = await Promise.allSettled([
                api.get(`/api/cnis/filiado/${filiadoId}/vinculos`),
                api.post(`/api/cnis/filiado/${filiadoId}/calcular-tempo`),
                api.post(`/api/cnis/filiado/${filiadoId}/calcular-tempo-convertido`),
                api.get(`/api/cnis/filiado/${filiadoId}/remuneracoes`)
            ]);

            const [vinculosRes, tempoSimplesRes, tempoConvertidoRes, remuneracoesRes] = results;

            if (vinculosRes.status === 'fulfilled') {
                const sortedVinculos = (vinculosRes.value.data || []).sort((a, b) => a.seq - b.seq);
                setVinculos(sortedVinculos);
            } else {
                setError('Erro ao buscar vínculos.');
                setVinculos([]);
            }

            if (tempoSimplesRes.status === 'fulfilled') {
                setTempoSimples(tempoSimplesRes.value.data.tempoFormatado || 'N/A');
            } else {
                setError('Erro ao calcular tempo simples.');
                setTempoSimples('Erro');
            }

            if (tempoConvertidoRes.status === 'fulfilled') {
                setTempoConvertido(tempoConvertidoRes.value.data.tempoFormatado || 'N/A');
            } else {
                setError('Erro ao calcular tempo convertido.');
                setTempoConvertido('Erro');
            }

            if (remuneracoesRes.status === 'fulfilled') {
                const sortedRemuneracoes = remuneracoesRes.value.data.sort((a, b) => a.id - b.id);
                setRemuneracoes(sortedRemuneracoes || []);
            } else {
                setError('Erro ao buscar remunerações.');
                setRemuneracoes([]);
            }

        } catch (err) {
            setError('Ocorreu um erro inesperado ao carregar os dados.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleProcessCnis = async () => {
        if (!file) {
            setError('Por favor, selecione um arquivo.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('sexo', sexo);
        formData.append('isProfessor', isProfessor);
        formData.append('isDeficiente', isDeficiente);
        if (isDeficiente) {
            formData.append('grauDeficiencia', grauDeficiencia);
        }

        setIsLoading(true);
        setError('');

        try {
            const response = await api.post('/api/cnis/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response.data.status === 'erro') {
                setError(response.data.mensagem);
                setFiliado(null);
                setVinculos([]);
            } else {
                const { filiado } = response.data;
                setFiliado(filiado);
                setSelectedFiliadoId(filiado ? filiado.id : null);

                setAposentadoriaResult(null);
                setCalculationResult({});
                setDescarteResult(null);
                setRemuneracoesNormalizadas([]);
                setDataReferencia('');

                await loadAllFiliados();

                if (filiado && filiado.id) {
                    loadDashboardData(filiado.id);
                }

                setFile(null);
                const fileInput = document.getElementById('cnisFile');
                if (fileInput) fileInput.value = '';

                setSexo(filiado.sexo || 'MASCULINO');
                setIsProfessor(filiado.isProfessor || false);
                setIsDeficiente(filiado.isDeficiente || false);
                setGrauDeficiencia(filiado.grauDeficiencia || 'LEVE');
            }
        } catch (err) {
            setError(err.response?.data?.mensagem || 'Erro ao conectar com o servidor.');
            setFiliado(null);
            setVinculos([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRecalculateAll = () => {
        if (filiado && filiado.id) {
            loadDashboardData(filiado.id);
        }
    }

    const handleDeleteFiliado = async () => {
        if (!filiado || !filiado.id) return;

        if (!window.confirm(`Tem certeza que deseja excluir o filiado ${filiado.nome}? Esta ação não pode ser desfeita.`)) {
            return;
        }

        setIsLoading(true);
        try {
            await api.delete(`/api/cnis/filiado/${filiado.id}`);
            setSuccessMessage('Filiado excluído com sucesso.');

            setFiliado(null);
            setVinculos([]);
            setRemuneracoes([]);
            setSelectedFiliadoId(null);
            setRemuneracoesNormalizadas([]);
            setAposentadoriaResult(null);
            setDescarteResult(null);
            setDataReferencia('');

            await loadAllFiliados();
        } catch (err) {
            console.error('Erro ao excluir filiado:', err);
            setError('Erro ao excluir filiado. Tente novamente.');
        } finally {
            setIsLoading(false);
        }
    };



    const handleDeleteVinculo = async (vinculoId) => {
        if (!window.confirm("Tem certeza que deseja excluir este vínculo?")) return;

        try {
            await api.delete(`/api/cnis/vinculos/${vinculoId}`);
            if (filiado && filiado.id) {
                loadDashboardData(filiado.id);
            }
        } catch (err) {
            setError('Erro ao excluir vínculo.');
        }
    };

    const handleAddVinculo = async (e) => {
        e.preventDefault();
        if (!filiado || !filiado.id) {
            setError("Nenhum filiado carregado para adicionar o vínculo.");
            return;
        }

        try {
            const vinculoData = {
                ...newVinculo,
                dataInicio: formatDateToISO(newVinculo.dataInicio),
                dataFim: newVinculo.dataFim ? formatDateToISO(newVinculo.dataFim) : ''
            };

            await api.post(`/api/cnis/filiado/${filiado.id}/vinculos`, vinculoData);
            setShowAddForm(false);
            setNewVinculo({ seq: '', dataInicio: '', dataFim: '', empresa: '', categoria: 'Empregado ou Agente Público' });
            loadDashboardData(filiado.id);
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao adicionar novo vínculo.');
        }
    };

    const handleNewVinculoChange = (e) => {
        const { name, value } = e.target;
        setNewVinculo(prev => ({ ...prev, [name]: value }));
    };

    const handleEditClick = (vinculo) => {
        setEditedVinculo({ ...vinculo });
    };

    const handleCancelEdit = () => {
        setEditedVinculo(null);
    };

    const handleUpdateVinculo = async () => {
        if (!editedVinculo) return;

        try {
            const { id, dataInicio, dataFim, tipoAtividade } = editedVinculo;
            const updatePromises = [];

            const dataInicioISO = dataInicio ? formatDateToISO(dataInicio) : '';
            const dataFimISO = dataFim ? formatDateToISO(dataFim) : '';

            if (!dataInicioISO) {
                setError('A data de início é obrigatória.');
                return;
            }

            updatePromises.push(
                api.put(`/api/cnis/vinculos/${id}/periodo`, {
                    dataInicio: dataInicioISO,
                    dataFim: dataFimISO || null
                })
            );

            updatePromises.push(
                api.put(`/api/cnis/vinculos/${id}/tipo-atividade`, { tipoAtividade })
            );

            updatePromises.push(
                api.put(`/api/cnis/vinculos/${id}/indicadores`, {
                    indicadorProfessor: editedVinculo.indicadorProfessor,
                    indicadorPcd: editedVinculo.indicadorPcd
                })
            );

            await Promise.all(updatePromises);

            setEditedVinculo(null);
            loadDashboardData(filiado.id);

        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao atualizar o vínculo.');
        }
    };

    const handleEditedVinculoChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setEditedVinculo(prev => ({ ...prev, [name]: val }));
    };

    const handleSplitClick = (vinculo) => {
        setEditedVinculo(null);
        setSplittingVinculo({
            id: vinculo.id,
            dataInicio: vinculo.dataInicio,
            dataFim: vinculo.dataFim,
            empresa: vinculo.empresa,
            seq: vinculo.seq,
            categoria: vinculo.categoria,
            dataCorte: '',
            tipoAtividadePrimeiro: 'ESPECIAL_25',
            tipoAtividadeSegundo: 'COMUM',
        });
    };

    const handleCancelSplit = () => {
        setSplittingVinculo(null);
    };

    const handleConfirmSplit = async () => {
        if (!splittingVinculo) return;
        if (!splittingVinculo.dataCorte || !isValidBRDate(splittingVinculo.dataCorte)) {
            setError('Informe uma data de corte válida (DD/MM/AAAA).');
            return;
        }
        try {
            const dataCorteISO = formatDateToISO(splittingVinculo.dataCorte);
            await api.post(`/api/cnis/vinculos/${splittingVinculo.id}/dividir`, {
                dataCorte: dataCorteISO,
                tipoAtividadePrimeiro: splittingVinculo.tipoAtividadePrimeiro,
                tipoAtividadeSegundo: splittingVinculo.tipoAtividadeSegundo,
            });
            setSplittingVinculo(null);
            setSuccessMessage('Vínculo dividido com sucesso.');
            loadDashboardData(filiado.id);
        } catch (err) {
            setError(err.response?.data?.mensagem || err.response?.data?.message || 'Erro ao dividir o vínculo.');
        }
    };

    const toggleCard = (cardName) => {
        setCardVisibility(prev => ({ ...prev, [cardName]: !prev[cardName] }));
    };

    const handleVerificarDireito = async () => {
        if (!filiado || !filiado.id) {
            setError("Nenhum filiado carregado para verificar o direito.");
            return;
        }
        if (!dib) {
            setError("Por favor, insira a Data de Início do Benefício (DIB) para verificação.");
            return;
        }

        if (!isValidBRDate(dib)) {
            setError("Por favor, insira a DIB no formato DD/MM/AAAA.");
            return;
        }

        if (availableCompetencies.length > 0) {
            const dibISO = formatDateToISO(dib);
            const dibDate = new Date(dibISO);
            const dibMonthYear = `${(dibDate.getMonth() + 1).toString().padStart(2, '0')}/${dibDate.getFullYear()}`;

            const latestComp = availableCompetencies[availableCompetencies.length - 1];
            const [latestMes, latestAno] = latestComp.split('/').map(Number);

            const dibMes = dibDate.getMonth() + 1;
            const dibAno = dibDate.getFullYear();

            if (dibAno > latestAno || (dibAno === latestAno && dibMes > latestMes)) {
                alert(`Atenção: A DIB selecionada (${dibMonthYear}) é posterior à última competência de INPC disponível (${latestComp}). O cálculo pode não ser preciso ou falhar.`);
            }
        }

        setIsLoading(true);
        setError('');
        setAposentadoriaResult(null);
        setDescarteResult(null);
        setRemuneracoesNormalizadas([]);
        setDataReferencia('');
        setProjectionResults({});
        setProjectionDropdownOpen(null);

        try {
            const dibISO = formatDateToISO(dib);

            try {
                await api.post('/api/inpc/validate', { dib: dibISO });
            } catch (valErr) {
                if (valErr.response && valErr.response.status === 400 && Array.isArray(valErr.response.data)) {
                    const missingMsg = valErr.response.data.join('\n');
                    throw new Error(`Erro de validação INPC:\n${missingMsg}`);
                }
                throw valErr;
            }

            const response = await api.post(`/api/aposentadoria/verificar/${filiado.id}`, {
                dib: dibISO,
                sexo: sexo,
                isProfessor: isProfessor,
                isDeficiente: isDeficiente,
                grauDeficiencia: isDeficiente ? grauDeficiencia : null
            });
            setAposentadoriaResult(response.data);

            // Fetch normalized remunerations for display (backend already normalized during verificar)
            const dibDate = new Date(dibISO);
            const mes = dibDate.getMonth() + 1;
            const ano = dibDate.getFullYear();
            try {
                const remResponse = await api.get(`/api/cnis/filiado/${filiado.id}/remuneracoes-normalizadas`, {
                    params: { mes, ano }
                });
                setRemuneracoesNormalizadas(remResponse.data || []);
                setDataReferencia(`${mes.toString().padStart(2, '0')}/${ano}`);
            } catch (remErr) {
                console.error("Erro ao buscar remunerações normalizadas:", remErr);
            }

            const newCalculationResult = {};
            if (response.data.regrasElegiveis) {
                response.data.regrasElegiveis.forEach(regra => {
                    if (regra.calculo) {
                        newCalculationResult[regra.nome] = {
                            sbResponse: regra.calculo,
                            rmiResponse: regra.calculo.rmiResponse,
                            idade: response.data.idade
                        };
                    }
                });
            }
            setCalculationResult(newCalculationResult);

            if (response.data.regrasElegiveis && response.data.regrasElegiveis.length > 0) {
                setActiveTab(0);
                setDescarteResult(response.data.regrasElegiveis[0].calculo);

                // Exportar cálculos como JSON para a pasta do filiado
                try {
                    const exportResponse = await api.post(`/api/aposentadoria/exportar/${filiado.id}`, {
                        dib: dibISO,
                        sexo: sexo,
                        isProfessor: isProfessor,
                        isDeficiente: isDeficiente,
                        grauDeficiencia: isDeficiente ? grauDeficiencia : null
                    });
                    console.log(`Cálculos exportados: ${exportResponse.data.totalArquivos} arquivo(s)`, exportResponse.data.arquivosGerados);
                } catch (exportErr) {
                    console.error("Erro ao exportar cálculos JSON:", exportErr);
                }
            } else {
                setRemuneracoesNormalizadas([]);
                setDataReferencia('');
                setDescarteResult(null);
            }
        } catch (err) {
            console.error("Erro ao verificar direito:", err);
            setError(err.response?.data?.message || err.message || 'Erro ao verificar direito à aposentadoria.');
            setRemuneracoesNormalizadas([]);
            setDataReferencia('');
        } finally {
            setIsLoading(false);
        }
    };






    const handleProjetar = async (nomeRegra, tipoProjecao, valorCustom) => {
        setProjectionDropdownOpen(null);
        setProjectionResults(prev => ({
            ...prev,
            [nomeRegra]: { loading: true, error: null, data: null }
        }));

        try {
            const dibISO = formatDateToISO(dib);
            const response = await api.post(`/api/aposentadoria/projetar/${filiado.id}`, {
                nomeRegra: nomeRegra,
                tipoProjecao: tipoProjecao,
                valorCustom: tipoProjecao === 'VALOR_PERSONALIZADO' ? valorCustom : null,
                sexoOverride: sexo,
                dibOriginal: dibISO
            });
            setProjectionResults(prev => ({
                ...prev,
                [nomeRegra]: { loading: false, error: null, data: response.data }
            }));
        } catch (err) {
            const errorMsg = err.response?.data?.error || err.response?.data?.message || err.message || 'Erro ao projetar aposentadoria.';
            setProjectionResults(prev => ({
                ...prev,
                [nomeRegra]: { loading: false, error: errorMsg, data: null }
            }));
        }
    };

    const clearProjection = (nomeRegra) => {
        setProjectionResults(prev => {
            const next = { ...prev };
            delete next[nomeRegra];
            return next;
        });
    };

    const handleRemuneracaoChange = (e) => {
        const { name, value } = e.target;
        if (editingRemuneracao) {
            setEditingRemuneracao(prev => ({ ...prev, [name]: value }));
        } else if (newRemuneracao) {
            setNewRemuneracao(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSaveRemuneracao = async (e) => {
        e.preventDefault();
        const remuneracaoParaSalvar = editingRemuneracao || newRemuneracao;
        if (!remuneracaoParaSalvar) return;

        const { id, competencia, valor, vinculoSeq } = remuneracaoParaSalvar;

        try {
            if (id) {
                await api.put(`/api/remuneracoes/${id}`, { competencia, valor });
            } else {
                if (!vinculoSeq) {
                    setError("O Sequencial do Vínculo é obrigatório para adicionar uma nova remuneração.");
                    return;
                }
                const response = await api.post(`/api/remuneracoes/vinculo/${vinculoSeq}`, { competencia, valor });
                if (response?.data?.id !== undefined && response?.data?.id !== null) {
                    setPendingRemuneracaoScroll({ id: response.data.id });
                } else {
                    setPendingRemuneracaoScroll({ vinculoSeq, competencia });
                }
            }
            setEditingRemuneracao(null);
            setNewRemuneracao(null);
            loadDashboardData(filiado.id);
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao salvar remuneração.');
        }
    };

    const handleEditRemuneracao = (rem) => {
        setNewRemuneracao(null);
        setEditingRemuneracao({ ...rem });
    };

    const handleAddNewRemuneracao = () => {
        setEditingRemuneracao(null);
        if (newRemuneracao) {
            setNewRemuneracao(null);
        } else {
            setNewRemuneracao({ id: null, competencia: 'MM/AAAA', valor: '0.00', vinculoSeq: '' });
        }
    };

    const handleDeleteRemuneracao = async (remuneracaoId) => {
        if (!window.confirm("Tem certeza que deseja excluir esta remuneração?")) return;
        try {
            await api.delete(`/api/remuneracoes/${remuneracaoId}`);
            loadDashboardData(filiado.id);
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao deletar remuneração.');
        }
    };

    const handleCancelEditRemuneracao = () => {
        setEditingRemuneracao(null);
        setNewRemuneracao(null);
    };

    const handleInpcUpload = async () => {
        if (!inpcFile) {
            setError('Por favor, selecione um arquivo INPC.');
            return;
        }
        const formData = new FormData();
        formData.append('file', inpcFile);

        setIsLoading(true);
        setError('');
        setSuccessMessage('');

        try {
            const response = await api.post('/api/inpc/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setSuccessMessage(response.data.message || 'Arquivo INPC processado com sucesso!');

            await loadInpcStatus();
            await loadAvailableCompetencies();

            setInpcFile(null);
            const fileInput = document.getElementById('inpcFilePainel');
            if (fileInput) fileInput.value = '';

        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao processar arquivo INPC.');
        } finally {
            setIsLoading(false);
        }
    };






    return (
        <div className="container-fluid mt-4 d-flex flex-column" style={{ height: '95vh' }}>
            <header className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="mp-page-intro">
                        <p className="eyebrow">Motor de cálculo</p>
                        <h1>Análise do CNIS</h1>
                        <p>Faça o upload do extrato CNIS para análise, edição e cálculo.</p>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
                        {filiados.length > 0 && (
                            <select
                                className="form-select form-select-sm"
                                value={selectedFiliadoId || ''}
                                onChange={(e) => handleFiliadoSelection(e.target.value)}
                                style={{ width: '350px' }}
                            >
                                <option value="">Selecione um filiado...</option>
                                {filiados.map(f => (
                                    <option key={f.id} value={f.id}>
                                        {f.nome} - {f.nit}
                                    </option>
                                ))}
                            </select>
                        )}
                        {filiado && (
                            <div className="d-flex align-items-center gap-2">
                                <span className="badge bg-secondary py-2">Filiado atual: {filiado.nome}</span>
                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={handleDeleteFiliado}
                                    title="Excluir Filiado"
                                >
                                    Excluir
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="row align-items-end mt-2 mb-3">
                    <div className="col-md-3">
                        <label htmlFor="dibGlobal" className="form-label mb-1 small">DIB</label>
                        <DateInput
                            id="dibGlobal"
                            value={dib}
                            onChange={setDib}
                            placeholder="DD/MM/AAAA"
                        />
                    </div>
                    <div className="col-md-9">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={handleVerificarDireito}
                            disabled={!filiado || isLoading || !dib}
                        >
                            {isLoading ? 'Calculando...' : 'Calcular Aposentadoria'}
                        </button>
                    </div>
                </div>
            </header>

            {error && (
                <div className="alert alert-danger alert-dismissible fade show" role="alert" style={{ whiteSpace: 'pre-wrap' }}>
                    {error}
                    <button type="button" className="btn-close" onClick={() => setError('')}></button>
                </div>
            )}
            {successMessage && (
                <div className="alert alert-success alert-dismissible fade show" role="alert">
                    {successMessage}
                    <button type="button" className="btn-close" onClick={() => setSuccessMessage('')}></button>
                </div>
            )}
            {isLoading && <div className="alert alert-info">Processando...</div>}

            <ul className="nav nav-tabs mb-3">
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeMainTab === 'calculo' ? 'active' : ''}`}
                        onClick={() => setActiveMainTab('calculo')}
                    >
                        Cálculo
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeMainTab === 'painel' ? 'active' : ''}`}
                        onClick={() => setActiveMainTab('painel')}
                    >
                        Painel de Controle
                    </button>
                </li>
            </ul>

            {activeMainTab === 'calculo' && (
            <>
            <div className="flex-grow-1">
                <Allotment>
                    <Allotment.Pane preferredSize="400px" minSize={300}>
                        <aside className="d-flex flex-column h-100 overflow-auto p-2">
                            <div className="card mb-4">
                                <div className="card-header" onClick={() => toggleCard('entrada')} style={{ cursor: 'pointer' }}><h4>Entrada de Dados</h4></div>
                                <div className={`collapse ${cardVisibility.entrada ? 'show' : ''}`}>
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <label htmlFor="cnisFile" className="form-label">Arquivo CNIS (.pdf)</label>
                                            <input type="file" className="form-control" id="cnisFile" onChange={handleFileChange} accept=".pdf" />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="sexo" className="form-label">Sexo</label>
                                            <select id="sexo" className="form-select" value={sexo} onChange={(e) => setSexo(e.target.value)}><option value="MASCULINO">Masculino</option><option value="FEMININO">Feminino</option></select>
                                        </div>
                                        <div className="mb-3 form-check">
                                            <input type="checkbox" className="form-check-input" id="isProfessor" checked={isProfessor} onChange={(e) => setIsProfessor(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="isProfessor">Professor</label>
                                        </div>
                                        <div className="mb-3 form-check">
                                            <input type="checkbox" className="form-check-input" id="isDeficiente" checked={isDeficiente} onChange={(e) => setIsDeficiente(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="isDeficiente">Pessoa com Deficiência (PCD)</label>
                                        </div>
                                        {isDeficiente && (
                                            <div className="mb-3">
                                                <label htmlFor="grauDeficiencia" className="form-label">Grau da Deficiência</label>
                                                <select id="grauDeficiencia" className="form-select" value={grauDeficiencia} onChange={(e) => setGrauDeficiencia(e.target.value)}>
                                                    <option value="LEVE">Leve</option>
                                                    <option value="MODERADA">Moderada</option>
                                                    <option value="GRAVE">Grave</option>
                                                </select>
                                            </div>
                                        )}
                                        <button className="btn btn-primary w-100" onClick={handleProcessCnis} disabled={isLoading}>{isLoading ? 'Processando...' : 'Processar CNIS'}</button>
                                    </div>
                                </div>
                            </div>
                            {filiado && (
                                <div className="card mb-4 flex-grow-1">
                                    <div className="card-header" onClick={() => toggleCard('resultados')} style={{ cursor: 'pointer' }}><h4>Elegibilidade a aposentadoria</h4></div>
                                    <div className={`collapse ${cardVisibility.resultados ? 'show' : ''}`}>
                                        <div className="card-body">
                                            <h5>Filiado</h5>
                                            <p className="mb-1"><strong>Nome:</strong> {filiado.nome}</p>
                                            <p><strong>NIT:</strong> {filiado.nit}</p>
                                            <p><strong>Sexo:</strong> {sexo}</p>
                                            {filiado.isProfessor && <p><strong>Professor:</strong> Sim</p>}
                                            {filiado.isDeficiente && <p><strong>PCD:</strong> Sim ({filiado.grauDeficiencia})</p>}
                                            <hr />
                                            <h5>Tempo de Contribuição</h5>
                                            <p><strong>Simples:</strong> {tempoSimples || 'N/A'}</p>
                                            <p><strong>Convertido:</strong> {tempoConvertido || 'N/A'}</p>
                                            <button className="btn btn-secondary btn-sm w-100 mb-3" onClick={handleRecalculateAll}>Recalcular Tempo</button>

                                            {aposentadoriaResult && (
                                                <div className="mt-3">
                                                    {(() => {
                                                        const getTipoBadge = (tipo) => {
                                                            switch (tipo) {
                                                                case 'PROFESSOR':
                                                                    return <span className="badge bg-info me-2">Professor</span>;
                                                                case 'PCD':
                                                                    return <span className="badge bg-warning text-dark me-2">PCD</span>;
                                                                case 'ESPECIAL':
                                                                    return <span className="badge bg-dark me-2">Especial</span>;
                                                                default:
                                                                    return <span className="badge bg-secondary me-2">Comum</span>;
                                                            }
                                                        };

                                                        const todasRegras = [...aposentadoriaResult.regrasElegiveis, ...aposentadoriaResult.regrasInelegiveis];
                                                        const regrasComuns = todasRegras.filter(r => !r.tipo || r.tipo === 'COMUM');
                                                        const regrasProfessor = todasRegras.filter(r => r.tipo === 'PROFESSOR');
                                                        const regrasPCD = todasRegras.filter(r => r.tipo === 'PCD');
                                                        const regrasEspeciais = todasRegras.filter(r => r.tipo === 'ESPECIAL');
                                                        // Agrupar regras especiais por categoria (15, 20, 25) — mantém a ordem definida pelo backend.
                                                        const categoriasEspeciais = aposentadoriaResult.categoriasEspeciais || [];
                                                        const regrasPorCategoria = categoriasEspeciais.reduce((acc, cat) => {
                                                            acc[cat] = regrasEspeciais.filter(r => r.nome.includes(`${cat} anos`));
                                                            return acc;
                                                        }, {});

                                                        const renderRegra = (regra) => {
                                                            const result = calculationResult[regra.nome];
                                                            const projection = projectionResults[regra.nome];
                                                            return (
                                                                <div key={regra.nome} className={`card mb-3 ${regra.elegivel ? 'border-success' : 'border-danger'}`}>
                                                                    <div className={`card-header ${regra.elegivel ? 'bg-success text-white' : 'bg-danger text-white'}`}>
                                                                        <h6 className="mb-0 d-flex align-items-center">
                                                                            {getTipoBadge(regra.tipo)}
                                                                            {regra.nome} - {regra.elegivel ? 'Elegível' : 'Inelegível'}
                                                                        </h6>
                                                                    </div>
                                                                    <div className="card-body">
                                                                        <p className="card-text">{regra.resumo}</p>
                                                                        {regra.criterios && regra.criterios.map(criterio => (
                                                                            <div key={criterio.nome} className="mb-2">
                                                                                <strong>{criterio.nome}:</strong> {criterio.valorAtual} / {criterio.valorNecessario}
                                                                                <div className="progress" style={{ height: '20px' }}>
                                                                                    <div className={`progress-bar ${criterio.progresso >= 1 ? 'bg-success' : 'bg-info'}`} role="progressbar" style={{ width: `${criterio.progresso * 100}%` }} aria-valuenow={criterio.progresso * 100} aria-valuemin="0" aria-valuemax="100">{`${(criterio.progresso * 100).toFixed(1)}%`}</div>
                                                                                </div>
                                                                            </div>
                                                                        ))}

                                                                        {result && (
                                                                            <div className="alert alert-info mt-2 p-2">
                                                                                <h6 className="alert-heading">Resumo do Cálculo</h6>
                                                                                <ul className="list-unstyled mb-0">
                                                                                    <li><strong>Idade na DIB:</strong> {result.idade} anos</li>
                                                                                    <li><strong>Parcelas no PBC:</strong> {result.sbResponse.numeroParcelasPbc}</li>
                                                                                    <li><strong>Soma dos {result.sbResponse.remuneracoesUtilizadas || result.sbResponse.numeroParcelasPbc} Salários:</strong> R$ {result.sbResponse.somaSalarios.toFixed(2)}</li>
                                                                                    {result.sbResponse.bonusTempoContribuicao > 0 && <li><strong>Bonus Tempo de Contribuição:</strong> +{result.sbResponse.bonusTempoContribuicao} anos</li>}
                                                                                    {result.sbResponse.fatorPrevidenciarioAplicado && <li><strong>Fator Previdenciário:</strong> {result.sbResponse.fatorPrevidenciarioAplicado.toFixed(4)}</li>}
                                                                                    <li><strong>Salário de Benefício:</strong> R$ {result.sbResponse.salarioBeneficio.toFixed(2)}</li>
                                                                                    {result.rmiResponse ? (
                                                                                        <>
                                                                                            <li><strong>Coeficiente RMI:</strong> {(result.rmiResponse.coeficiente * 100).toFixed(2)}%</li>
                                                                                            <li className="mt-2 fs-5"><strong>Renda Mensal Inicial (RMI):</strong> R$ {result.rmiResponse.valorRmi.toFixed(2)}</li>
                                                                                        </>
                                                                                    ) : (
                                                                                        <li className="mt-2 text-warning"><strong>RMI:</strong> Cálculo não disponível (verifique se há remunerações no período básico)</li>
                                                                                    )}
                                                                                </ul>
                                                                            </div>
                                                                        )}

                                                                        {/* Projeção: botão para regras inelegíveis projetáveis */}
                                                                        {!regra.elegivel && regra.projetavel && !projection?.data && !projection?.loading && (
                                                                            <ProjecaoDropdown
                                                                                regraNome={regra.nome}
                                                                                isLoading={false}
                                                                                isOpen={projectionDropdownOpen === regra.nome}
                                                                                onToggle={() => setProjectionDropdownOpen(
                                                                                    projectionDropdownOpen === regra.nome ? null : regra.nome
                                                                                )}
                                                                                onProject={handleProjetar}
                                                                            />
                                                                        )}

                                                                        {/* Projeção: loading */}
                                                                        {projection?.loading && (
                                                                            <div className="d-flex align-items-center mt-3">
                                                                                <div className="spinner-border spinner-border-sm text-warning me-2" role="status">
                                                                                    <span className="visually-hidden">Projetando...</span>
                                                                                </div>
                                                                                <small className="text-muted">Calculando projeção...</small>
                                                                            </div>
                                                                        )}

                                                                        {/* Projeção: erro */}
                                                                        {projection?.error && (
                                                                            <div className="alert alert-warning mt-2 p-2 d-flex justify-content-between align-items-center">
                                                                                <small>{projection.error}</small>
                                                                                <button className="btn btn-sm btn-outline-warning ms-2"
                                                                                    onClick={() => clearProjection(regra.nome)}>
                                                                                    Tentar novamente
                                                                                </button>
                                                                            </div>
                                                                        )}

                                                                        {/* Projeção: resultado */}
                                                                        {projection?.data && (
                                                                            <ProjecaoResultado
                                                                                resultado={projection.data}
                                                                                onClear={() => clearProjection(regra.nome)}
                                                                                onVerDescarte={() => {
                                                                                    setDescarteResult(projection.data.regraProjetada.calculo);
                                                                                    setShowDescarteFullscreen(true);
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        };

                                                        return (
                                                            <>
                                                                {regrasComuns.length > 0 && (
                                                                    <div className="mb-4">
                                                                        <h6 className="border-bottom pb-2 mb-3">
                                                                            <span className="badge bg-secondary me-2">Comum</span>
                                                                            Regras Comuns
                                                                        </h6>
                                                                        {regrasComuns.map(renderRegra)}
                                                                    </div>
                                                                )}

                                                                {regrasProfessor.length > 0 && (
                                                                    <div className="mb-4">
                                                                        <h6 className="border-bottom pb-2 mb-3">
                                                                            <span className="badge bg-info me-2">Professor</span>
                                                                            Regras de Professor
                                                                        </h6>
                                                                        {regrasProfessor.map(renderRegra)}
                                                                    </div>
                                                                )}

                                                                {regrasPCD.length > 0 && (
                                                                    <div className="mb-4">
                                                                        <h6 className="border-bottom pb-2 mb-3">
                                                                            <span className="badge bg-warning text-dark me-2">PCD</span>
                                                                            Regras de PCD
                                                                        </h6>
                                                                        {regrasPCD.map(renderRegra)}
                                                                    </div>
                                                                )}

                                                                {aposentadoriaResult.temVinculoEspecial && categoriasEspeciais.map(cat => (
                                                                    regrasPorCategoria[cat] && regrasPorCategoria[cat].length > 0 && (
                                                                        <div key={`especial-${cat}`} className="mb-4">
                                                                            <h6 className="border-bottom pb-2 mb-3">
                                                                                <span className="badge bg-dark me-2">Especial {cat}a</span>
                                                                                Aposentadoria Especial {cat} anos
                                                                            </h6>
                                                                            {regrasPorCategoria[cat].map(renderRegra)}
                                                                        </div>
                                                                    )
                                                                ))}
                                                            </>
                                                        );
                                                    })()}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </aside>
                    </Allotment.Pane>
                    <Allotment.Pane>
                        <Allotment vertical={true}>
                            <Allotment.Pane>
                                <main className="h-100 d-flex flex-column">
                                    <div className="card h-100 d-flex flex-column">
                                        <div className="card-header d-flex justify-content-between align-items-center" onClick={() => toggleCard('vinculos')} style={{ cursor: 'pointer' }}>
                                            <h4>Vínculos empregatícios</h4>
                                            {cardVisibility.vinculos && <button className="btn btn-success btn-sm" onClick={(e) => { e.stopPropagation(); setShowAddForm(!showAddForm); }} disabled={!filiado}>{showAddForm ? 'Cancelar' : '+ Adicionar Vínculo'}</button>}
                                        </div>
                                        <div className={`card-body h-100 overflow-auto collapse ${cardVisibility.vinculos ? 'show' : ''}`}>
                                            {showAddForm && (
                                                <div className="card bg-light mb-4"><div className="card-body" onClick={(e) => e.stopPropagation()}>
                                                    <h5>Adicionar Novo Vínculo</h5>
                                                    <form onSubmit={handleAddVinculo}><div className="row g-3"><div className="col-md-2"><label className="form-label">Seq.</label><input type="number" name="seq" value={newVinculo.seq} onChange={handleNewVinculoChange} className="form-control" required /></div><div className="col-md-5"><label className="form-label">Empresa</label><input type="text" name="empresa" value={newVinculo.empresa} onChange={handleNewVinculoChange} className="form-control" required /></div><div className="col-md-5"><label className="form-label">Categoria</label><input type="text" name="categoria" value={newVinculo.categoria} onChange={handleNewVinculoChange} className="form-control" required /></div><div className="col-md-6"><label className="form-label">Data Início</label><DateInput name="dataInicio" value={newVinculo.dataInicio} onChange={(val) => setNewVinculo(prev => ({ ...prev, dataInicio: val }))} className="form-control" /></div><div className="col-md-6"><label className="form-label">Data Fim (opcional)</label><DateInput name="dataFim" value={newVinculo.dataFim} onChange={(val) => setNewVinculo(prev => ({ ...prev, dataFim: val }))} className="form-control" /></div><div className="col-12"><button type="submit" className="btn btn-primary">Salvar Vínculo</button></div></div></form>
                                                </div></div>
                                            )}
                                            <div className="table-responsive"><table className="table table-striped table-hover table-sm"><thead><tr><th style={{ width: "4%" }}>#</th><th style={{ width: "35%" }}>Empresa</th><th>Categoria</th><th style={{ width: "8%" }}>Início</th><th style={{ width: "8%" }}>Fim</th><th style={{ width: "10%" }}>Tempo Especial</th>
                                                {filiado && filiado.isProfessor && <th style={{ width: "5%" }}>Prof.</th>}
                                                {filiado && filiado.isDeficiente && <th style={{ width: "5%" }}>PCD</th>}
                                                <th>Ações</th></tr></thead>
                                                <tbody>
                                                    {vinculos.length > 0 ? vinculos.map(v => {
                                                        const extraCols = (filiado && filiado.isProfessor ? 1 : 0) + (filiado && filiado.isDeficiente ? 1 : 0);
                                                        const splitMiddleColSpan = 5 + extraCols; // empresa, categoria, início, fim, tempo especial + opcionais
                                                        const isSplitting = splittingVinculo && splittingVinculo.id === v.id;
                                                        const isEditing = editedVinculo && editedVinculo.id === v.id;
                                                        return (
                                                        <tr key={v.id}>
                                                            {isEditing ? (
                                                                <>
                                                                    <td>{v.seq}</td><td>{v.empresa}</td><td style={{ width: "25%" }}>{v.categoria}</td>
                                                                    <td><DateInput name="dataInicio" value={editedVinculo.dataInicio} onChange={(val) => setEditedVinculo(prev => ({ ...prev, dataInicio: val }))} className="form-control form-control-sm" /></td>
                                                                    <td><DateInput name="dataFim" value={editedVinculo.dataFim} onChange={(val) => setEditedVinculo(prev => ({ ...prev, dataFim: val }))} className="form-control form-control-sm" /></td>
                                                                    <td><select name="tipoAtividade" className="form-select form-select-sm" value={editedVinculo.tipoAtividade || 'COMUM'} onChange={handleEditedVinculoChange}><option value="COMUM">COMUM</option><option value="ESPECIAL_15">ESPECIAL_15</option><option value="ESPECIAL_20">ESPECIAL_20</option><option value="ESPECIAL_25">ESPECIAL_25</option></select></td>
                                                                    {filiado && filiado.isProfessor && <td><input type="checkbox" name="indicadorProfessor" checked={editedVinculo.indicadorProfessor || false} onChange={handleEditedVinculoChange} /></td>}
                                                                    {filiado && filiado.isDeficiente && <td><input type="checkbox" name="indicadorPcd" checked={editedVinculo.indicadorPcd || false} onChange={handleEditedVinculoChange} /></td>}
                                                                    <td className="d-flex flex-nowrap"><button className="btn btn-sm btn-success me-1" onClick={handleUpdateVinculo}>💾</button><button className="btn btn-sm btn-secondary" onClick={handleCancelEdit}>❌</button></td>
                                                                </>
                                                            ) : isSplitting ? (
                                                                <>
                                                                    <td>{v.seq}</td>
                                                                    <td colSpan={splitMiddleColSpan}>
                                                                        <div className="d-flex flex-wrap align-items-center gap-2">
                                                                            <span className="text-muted small">Dividir <strong>{v.empresa}</strong> ({formatDateToBR(v.dataInicio)} → {formatDateToBR(v.dataFim)})</span>
                                                                            <span className="small">Corte:</span>
                                                                            <div style={{ width: '120px' }}>
                                                                                <DateInput value={splittingVinculo.dataCorte} onChange={(val) => setSplittingVinculo(prev => ({ ...prev, dataCorte: val }))} className="form-control form-control-sm" />
                                                                            </div>
                                                                            <span className="small">1º:</span>
                                                                            <select className="form-select form-select-sm" style={{ width: 'auto' }} value={splittingVinculo.tipoAtividadePrimeiro} onChange={(e) => setSplittingVinculo(prev => ({ ...prev, tipoAtividadePrimeiro: e.target.value }))}>
                                                                                <option value="COMUM">COMUM</option>
                                                                                <option value="ESPECIAL_15">ESPECIAL_15</option>
                                                                                <option value="ESPECIAL_20">ESPECIAL_20</option>
                                                                                <option value="ESPECIAL_25">ESPECIAL_25</option>
                                                                            </select>
                                                                            <span className="small">2º:</span>
                                                                            <select className="form-select form-select-sm" style={{ width: 'auto' }} value={splittingVinculo.tipoAtividadeSegundo} onChange={(e) => setSplittingVinculo(prev => ({ ...prev, tipoAtividadeSegundo: e.target.value }))}>
                                                                                <option value="COMUM">COMUM</option>
                                                                                <option value="ESPECIAL_15">ESPECIAL_15</option>
                                                                                <option value="ESPECIAL_20">ESPECIAL_20</option>
                                                                                <option value="ESPECIAL_25">ESPECIAL_25</option>
                                                                            </select>
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-flex flex-nowrap"><button className="btn btn-sm btn-success me-1" onClick={handleConfirmSplit} title="Confirmar divisão">💾</button><button className="btn btn-sm btn-secondary" onClick={handleCancelSplit} title="Cancelar">❌</button></td>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <td>{v.seq}</td><td>{v.empresa}</td><td style={{ width: "25%" }}>{v.categoria}</td><td>{formatDateToBR(v.dataInicio)}</td><td>{v.dataFim ? formatDateToBR(v.dataFim) : 'Em aberto'}</td><td>{v.tipoAtividade || 'COMUM'}</td>
                                                                    {filiado && filiado.isProfessor && <td>{v.indicadorProfessor ? 'Sim' : ''}</td>}
                                                                    {filiado && filiado.isDeficiente && <td>{v.indicadorPcd ? 'Sim' : ''}</td>}
                                                                    <td className="d-flex flex-nowrap">
                                                                        <button className="btn btn-sm btn-outline-primary me-1" onClick={() => handleEditClick(v)} title="Editar">✏️</button>
                                                                        {v.dataFim && <button className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSplitClick(v)} title="Dividir período">✂️</button>}
                                                                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteVinculo(v.id)} title="Excluir">🗑️</button>
                                                                    </td>
                                                                </>
                                                            )}
                                                        </tr>
                                                        );
                                                    }) : <tr><td colSpan={7 + (filiado && filiado.isProfessor ? 1 : 0) + (filiado && filiado.isDeficiente ? 1 : 0)} className="text-center">Nenhum vínculo encontrado.</td></tr>}
                                                </tbody>
                                            </table></div>
                                        </div>
                                    </div>
                                </main>
                            </Allotment.Pane>
                            <Allotment.Pane>
                                <section className="h-100 d-flex flex-column">
                                    {filiado && (
                                        <div className="card h-100 d-flex flex-column">
                                            <div className="card-header d-flex justify-content-between align-items-center" onClick={() => toggleCard('remuneracoes')} style={{ cursor: 'pointer' }}>
                                                <h4>Remunerações</h4>
                                                <div className="d-flex align-items-center">
                                                    <button className="btn btn-success btn-sm" onClick={(e) => { e.stopPropagation(); handleAddNewRemuneracao(); }}>
                                                        {newRemuneracao ? 'Cancelar' : '+ Adicionar Remuneração'}
                                                    </button>
                                                </div>
                                            </div>
                                            <div ref={remuneracoesContainerRef} className={`card-body h-100 overflow-auto collapse ${cardVisibility.remuneracoes ? 'show' : ''}`}>
                                                {remuneracoesNormalizadas.length > 0 && (
                                                    <div className="alert alert-success mb-3">
                                                        <strong>✓ Remunerações Normalizadas automaticamente para a data do DIB.</strong>
                                                        {dataReferencia && <span> (Referência: {dataReferencia})</span>}
                                                    </div>
                                                )}

                                                {newRemuneracao && (
                                                    <div className="card bg-light mb-3"><div className="card-body" onClick={(e) => e.stopPropagation()}>
                                                        <h5>Adicionar Remuneração</h5>
                                                        <form onSubmit={handleSaveRemuneracao}>
                                                            <div className="row g-2 align-items-end">
                                                                <div className="col-md-3">
                                                                    <label className="form-label">Vínculo Seq.</label>
                                                                    <input type="number" name="vinculoSeq" value={newRemuneracao.vinculoSeq} onChange={handleRemuneracaoChange} className="form-control" required />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label">Competência</label>
                                                                    <input type="text" name="competencia" value={newRemuneracao.competencia} onChange={handleRemuneracaoChange} className="form-control" placeholder="MM/AAAA" required />
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label className="form-label">Valor (R$)</label>
                                                                    <input type="number" step="0.01" name="valor" value={newRemuneracao.valor} onChange={handleRemuneracaoChange} className="form-control" required />
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <button type="submit" className="btn btn-primary">Salvar</button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div></div>
                                                )}
                                                <table className="table table-sm table-striped">
                                                    <thead><tr><th>Vínculo Seq.</th><th>Competência</th><th>Valor (R$)</th><th>Valor Normalizado (R$)</th><th>{'>'}= Sal. Mínimo?</th><th>Ações</th></tr></thead>
                                                    <tbody>
                                                        {remuneracoes.map(rem => {
                                                            const normalizada = remuneracoesNormalizadas.find(n => n.vinculoSeq === rem.vinculoSeq && n.competencia === rem.competencia);
                                                            return (
                                                                editingRemuneracao && editingRemuneracao.id === rem.id ? (
                                                                    <tr key={rem.id} data-remuneracao-id={rem.id} data-vinculo-seq={rem.vinculoSeq} data-competencia={rem.competencia}>
                                                                        <td>{rem.vinculoSeq}</td>
                                                                        <td><input type="text" name="competencia" value={editingRemuneracao.competencia} onChange={handleRemuneracaoChange} className="form-control form-control-sm" /></td>
                                                                        <td><input type="number" step="0.01" name="valor" value={editingRemuneracao.valor} onChange={handleRemuneracaoChange} className="form-control form-control-sm" /></td>
                                                                        <td>{normalizada ? normalizada.valorNormalizado.toFixed(2) : 'N/A'}</td>
                                                                        <td>{rem.maiorIgualSalarioMinimo ? <span className="badge bg-success">Sim</span> : <span className="badge bg-danger">Não</span>}</td>
                                                                        <td><button className="btn btn-sm btn-success me-1" onClick={handleSaveRemuneracao}>💾</button><button className="btn btn-sm btn-secondary" onClick={handleCancelEditRemuneracao}>❌</button></td>
                                                                    </tr>
                                                                ) : (
                                                                    <tr key={rem.id} data-remuneracao-id={rem.id} data-vinculo-seq={rem.vinculoSeq} data-competencia={rem.competencia}>
                                                                        <td>{rem.vinculoSeq}</td><td>{rem.competencia}</td><td>{rem.valor.toFixed(2)}</td><td>{normalizada ? normalizada.valorNormalizado.toFixed(2) : 'N/A'}</td>
                                                                        <td>{rem.maiorIgualSalarioMinimo ? <span className="badge bg-success">Sim</span> : <span className="badge bg-danger">Não</span>}</td>
                                                                        <td><button className="btn btn-sm btn-outline-primary me-1" onClick={() => handleEditRemuneracao(rem)}>✏️</button><button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteRemuneracao(rem.id)}>🗑️</button></td>
                                                                    </tr>
                                                                )
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </section>
                            </Allotment.Pane>
                        </Allotment>
                    </Allotment.Pane>
                </Allotment>
            </div>

            {filiado && aposentadoriaResult && (
                <div className="mt-4">
                    <div className="card">
                        <div
                            className="card-header d-flex justify-content-between align-items-center"
                            onClick={() => toggleCard('descarte')}
                            style={{ cursor: 'pointer' }}
                        >
                            <h4>Cálculo da R.M.I.</h4>
                            {cardVisibility.descarte && descarteResult && (
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={(e) => { e.stopPropagation(); setShowDescarteFullscreen(true); }}
                                >
                                    📊 Ver Descarte
                                </button>
                            )}
                        </div>
                        <div className={`card-body collapse ${cardVisibility.descarte ? 'show' : ''}`}>

                            {aposentadoriaResult.regrasElegiveis && aposentadoriaResult.regrasElegiveis.length > 0 ? (
                                <>
                                    <ul className="nav nav-tabs mb-3 flex-wrap">
                                        {aposentadoriaResult.regrasElegiveis.map((regra, index) => {
                                            const tipoBadge = regra.tipo === 'PROFESSOR'
                                                ? <span className="badge bg-info me-1" style={{fontSize: '0.65em'}}>Prof</span>
                                                : regra.tipo === 'PCD'
                                                    ? <span className="badge bg-warning text-dark me-1" style={{fontSize: '0.65em'}}>PCD</span>
                                                    : null;
                                            return (
                                                <li className="nav-item" key={index}>
                                                    <button
                                                        className={`nav-link ${activeTab === index ? 'active' : ''}`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setActiveTab(index);
                                                            setDescarteResult(regra.calculo);
                                                        }}
                                                    >
                                                        {tipoBadge}{regra.nome}
                                                    </button>
                                                </li>
                                            );
                                        })}
                                    </ul>

                                    {descarteResult ? (
                                        <div className="alert alert-light border">
                                            <h6>Resultado do Descarte - {aposentadoriaResult.regrasElegiveis[activeTab]?.nome}</h6>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <p><strong>Total de Remunerações:</strong> {descarteResult.totalRemuneracoes}</p>
                                                    <p><strong>Utilizadas:</strong> {descarteResult.remuneracoesUtilizadas}</p>
                                                    <p><strong>Descartadas:</strong> {descarteResult.remuneracoesDescartadas}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <p><strong>Média sem Descarte:</strong> R$ {descarteResult.mediaSemDescarte?.toFixed(2)}</p>
                                                    <p><strong>Média com Descarte:</strong> R$ {descarteResult.mediaComDescarte?.toFixed(2)}</p>
                                                    {descarteResult.fatorPrevidenciarioAplicado ? (
                                                        <>
                                                            <p className="text-primary mb-1">
                                                                <small>x Fator Previdenciário: {descarteResult.fatorPrevidenciarioAplicado.toFixed(4)}</small>
                                                            </p>
                                                            <div className="border-top my-1"></div>
                                                            <p><strong>Salário de Benefício:</strong> R$ {descarteResult.salarioBeneficio?.toFixed(2)}</p>
                                                        </>
                                                    ) : (
                                                        <p><strong>Salário de Benefício:</strong> R$ {descarteResult.salarioBeneficio?.toFixed(2)}</p>
                                                    )}
                                                    {descarteResult.rmiResponse && (
                                                        <>
                                                            <p className="text-primary mb-1">
                                                                <small>Coeficiente RMI: {(descarteResult.rmiResponse.coeficiente * 100).toFixed(2)}%</small>
                                                            </p>
                                                            <div className="border-top my-1"></div>
                                                            <p><strong>Renda Mensal Inicial:</strong> R$ {descarteResult.rmiResponse.valorRmi.toFixed(2)}</p>
                                                        </>
                                                    )}
                                                    {descarteResult.rmiCorrigida && (
                                                        <p><strong>RMI Corrigida até a DIB:</strong> R$ {descarteResult.rmiCorrigida.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="alert alert-warning">
                                            Cálculo não disponível para esta regra.
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="alert alert-warning">
                                    Nenhuma regra elegível para exibir descarte.
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showDescarteFullscreen && descarteResult && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-fullscreen">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Detalhes do Descarte de Remunerações - {descarteResult.regraNome || aposentadoriaResult?.regrasElegiveis?.[activeTab]?.nome || ''}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowDescarteFullscreen(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-4">
                                    <div className="col-md-12">
                                        <div className="card bg-light">
                                            <div className="card-body">
                                                <h6 className="card-title">Cálculo da R.M.I.:</h6>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <p className="mb-1"><strong>Nº de Parcelas no PBC:</strong> <span className="float-end">{descarteResult.numeroParcelasPbc}</span></p>
                                                        <p className="mb-1"><strong>{descarteResult.regraNome?.includes("Direito Adquirido") ? "Idade em 13/11/2019:" : "Idade na DIB:"}</strong> <span className="float-end">{descarteResult.idade?.toFixed(2)} anos</span></p>
                                                        <p className="mb-1"><strong>Tempo de Contribuição:</strong> <span className="float-end">{descarteResult.tempoContribuicaoAnos?.toFixed(2)} anos</span></p>
                                                        <br />
                                                        <p className="mb-1"><strong>Soma dos {descarteResult.remuneracoesUtilizadas || descarteResult.numeroParcelasPbc} Salários:</strong> <span className="float-end">R$ {descarteResult.somaSalarios?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></p>
                                                        <p className="mb-1"><strong>Média dos Salários:</strong> <span className="float-end">R$ {(descarteResult.somaSalarios / (descarteResult.remuneracoesUtilizadas || descarteResult.numeroParcelasPbc))?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        {descarteResult.expectativaSobrevida && (
                                                            <p className="mb-1"><strong>Expectativa de Sobrevida:</strong> <span className="float-end">{descarteResult.expectativaSobrevida.toFixed(1)} anos</span></p>
                                                        )}
                                                        {descarteResult.bonusTempoContribuicao > 0 && (
                                                            <p className="mb-1"><strong>Bonus Tempo de Contribuição:</strong> <span className="float-end">+{descarteResult.bonusTempoContribuicao} anos</span></p>
                                                        )}
                                                        {descarteResult.fatorPrevidenciarioAplicado && (
                                                            <p className="mb-1"><strong>Fator Previdenciário:</strong> <span className="float-end">{descarteResult.fatorPrevidenciarioAplicado.toFixed(4)}</span></p>
                                                        )}
                                                        <p className="mb-1"><strong>Salário de Benefício:</strong> <span className="float-end">{descarteResult.salarioBeneficio?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></p>

                                                        {descarteResult.rmiResponse && (
                                                            <p className="mb-1"><strong>Coeficiente:</strong> <span className="float-end">{(descarteResult.rmiResponse.coeficiente * 100).toFixed(2)} %</span></p>
                                                        )}

                                                        {descarteResult.rmiResponse && (
                                                            <div className="alert alert-secondary py-1 px-2 mt-2 mb-1">
                                                                <strong>Renda Mensal Inicial:</strong> <span className="float-end"><strong>R$ {descarteResult.rmiResponse.valorRmi.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></span>
                                                            </div>
                                                        )}

                                                        {descarteResult.rmiCorrigida && (
                                                            <p className="mb-1"><strong>RMI Corrigida até a DIB:</strong> <span className="float-end">{descarteResult.rmiCorrigida.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></p>
                                                        )}
                                                    </div>
                                                </div>
                                                {descarteResult.rmiCorrigida && (
                                                    <div className="mt-2 text-muted fst-italic small border p-1">
                                                        Valor da RMI corrigido de 13/11/2019 até a DIB
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {descarteResult.descarteAplicado && (
                                    <div>
                                        <h6>Remunerações Processadas</h6>
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th>Competência</th>
                                                        <th>Valor Original</th>
                                                        <th>Valor Normalizado</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {descarteResult.remuneracoesComDescarte?.map((rem, index) => (
                                                        <tr key={index} className={rem.descartada ? 'table-secondary' : rem.projetada ? 'table-warning' : 'table-success'}>
                                                            <td>{rem.competencia}</td>
                                                            <td>R$ {rem.valorOriginal?.toFixed(2)}</td>
                                                            <td>R$ {rem.valorNormalizado?.toFixed(2)}</td>
                                                            <td>
                                                                {rem.projetada && <span className="badge bg-warning text-dark me-1">Projetada</span>}
                                                                <span className={`badge ${rem.descartada ? 'bg-secondary' : 'bg-success'}`}>
                                                                    {rem.descartada ? 'Descartada' : 'Utilizada'}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowDescarteFullscreen(false)}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            </>
            )}

            {activeMainTab === 'painel' && (
            <div className="flex-grow-1 overflow-auto">
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-4">
                            <div className="card-header">
                                <h4>Índices INPC</h4>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="inpcFilePainel" className="form-label">Arquivo INPC (.xlsx)</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="inpcFilePainel"
                                        onChange={(e) => setInpcFile(e.target.files[0])}
                                        accept=".xlsx"
                                    />
                                </div>
                                <button
                                    className="btn btn-secondary me-2"
                                    onClick={handleInpcUpload}
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Processando...' : 'Processar INPC'}
                                </button>
                                <span className={`badge ${inpcStatus.competenciasReferencia?.length > 0 ? 'bg-success' : 'bg-secondary'}`}>
                                    {inpcStatus.competenciasReferencia?.length > 0
                                        ? `Carregado (${inpcStatus.competenciasReferencia.join(', ')})`
                                        : 'Não carregado'}
                                </span>
                            </div>
                        </div>

                        <div className="card mb-4">
                            <div className="card-header">
                                <h4>Tábua de Mortalidade IBGE (Unissex)</h4>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="card bg-light">
                                            <div className="card-body">
                                                <h5 className="card-title">Tábua Unissex</h5>
                                                <div className="mb-3">
                                                    <label htmlFor="mortalidadeFile" className="form-label">
                                                        Arquivo (.xlsx)
                                                    </label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        id="mortalidadeFile"
                                                        onChange={(e) => setMortalidadeFile(e.target.files[0])}
                                                        accept=".xlsx"
                                                    />
                                                </div>
                                                <button
                                                    className="btn btn-primary me-2"
                                                    onClick={() => handleMortalidadeUpload()}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? 'Importando...' : 'Importar'}
                                                </button>
                                                <span className={`badge ${mortalidadeStatus.disponivel ? 'bg-success' : 'bg-secondary'}`}>
                                                    {mortalidadeStatus.disponivel
                                                        ? `Carregada (${mortalidadeStatus.ano})`
                                                        : 'Não carregada'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
}

export default DashboardPage;
